import ReactMarkdown from "react-markdown";

const pClass = "mt-4 text-[17px] leading-relaxed text-zinc-800 first:mt-0";
const strongClass = "font-bold text-zinc-950";

export function BlogMarkdown({ markdown }: { markdown: string }) {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => <p className={pClass}>{children}</p>,
        strong: ({ children }) => <strong className={strongClass}>{children}</strong>,
        em: ({ children }) => <em className="italic text-zinc-800">{children}</em>,
        ul: ({ children }) => <ul className="mt-4 list-disc space-y-2 pl-6 text-zinc-800">{children}</ul>,
        ol: ({ children }) => <ol className="mt-4 list-decimal space-y-2 pl-6 text-zinc-800">{children}</ol>,
        li: ({ children }) => <li className="leading-relaxed">{children}</li>,
        a: ({ href, children }) => (
          <a
            href={href}
            className="font-semibold text-violet-700 underline-offset-2 hover:underline"
            rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
            target={href?.startsWith("http") ? "_blank" : undefined}
          >
            {children}
          </a>
        ),
      }}
    >
      {markdown}
    </ReactMarkdown>
  );
}
